import { gql } from "@apollo/client";

/* eslint-disable camelcase */
export enum BackgroundFactorIndicatorLabel {
  school_tempen_students = "Skoltempen elever",
  absence_total_percentage = "Frånvaro",
  students_per_teacher = "Elever per lärare",
  teacher_sick_leave = "Sjukfrånvaro",
  staff_turnover = "Personalomsättning",
  foreign_background = "Elever med utländsk bakgrund",
  teachers_with_degrees_in_special_education = "Lärare med pedagogisk examen",
  parents_with_higher_education = "Föräldrar med akademisk utbildning",
  teacher_questionnaire = "HME",
}

export enum BackgroundFactorIndicatorCamelCaseKeyLabel {
  absencePercentage = "Frånvaro",
  schoolTempenStudents = "Skoltempen elever",
  studentsPerTeacher = "Elever per lärare",
  foreignBackground = "Elever med utländsk bakgrund",
  teachersSpecialEducation = "Lärare med pedagogisk examen",
  parentsHigherEducation = "Föräldrar med akademisk utbildning",
  staffTurnover = "Personalomsättning",
  teacherQuestionnaire = "HME",
  teacherSickLeave = "Sjukfrånvaro",
}

export const BackgroundService = {
  GET_BACKGROUND_FACTORS_MEAN_IMPACT_VALUES: gql`
    query FeaturesMeanImpactGbpEligibility($municipalityId: Int!) {
      featuresMeanImpactGbpEligibility(municipalityId: $municipalityId) {
        name
        eligibilityImpactValue
        gBPImpactValue
      }
    }
  `,
};
